import { defineComponent as _defineComponent } from 'vue';
import DatasetIndex from "@/components/Dataset/DatasetIndex/DatasetIndex.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetIndex',
    props: {
        args: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, DatasetIndex };
    }
});
